import React from 'react';
import api from '@/lib/api';
import { ExternalLink, Star, Check, Zap, Trophy, Shield, Award } from 'lucide-react';
import { toast } from 'sonner';

const BITSTARZ_LOGO = 'https://customer-assets.emergentagent.com/job_smart-player-hub/artifacts/cnni6myb_logo-light.png';
const BITSTARZ_LINK = 'https://bzstarz1.com/bhi8kvogt';

export default function CasinoSidebar({ sourcePage = 'dashboard' }) {
  const affiliateUrl = `${BITSTARZ_LINK}?utm_source=casinoiq&utm_medium=${sourcePage}&utm_campaign=smart-player-tools`;

  const handleClick = async () => {
    try {
      await api.post('/affiliate/click', { casino_id: 'bitstarz', source_page: sourcePage });
    } catch {}
    window.open(affiliateUrl, '_blank', 'noopener');
  };

  return (
    <div className="w-full lg:w-[300px] shrink-0" data-testid="casino-sidebar">
      <div className="ciq-card sticky top-20">
        <div className="flex items-center gap-2 mb-3">
          <Star className="h-4 w-4 text-[#f59e0b] fill-[#f59e0b]" />
          <span className="text-xs font-semibold text-[#f59e0b] uppercase tracking-wider">Featured Casino Partner</span>
        </div>
        <div className="w-full h-16 rounded-lg bg-black flex items-center justify-center mb-4 overflow-hidden p-2">
          <img src={BITSTARZ_LOGO} alt="BitStarz Casino" className="h-full object-contain" data-testid="bitstarz-sidebar-logo" />
        </div>
        <h3 className="text-white font-semibold text-lg mb-1" data-testid="sidebar-bonus-headline">Get $500 or 5 BTC + 180 Free Spins</h3>
        <p className="text-[10px] text-[#64748b] mb-3">40x wagering | Min deposit $20</p>
        <ul className="space-y-2 mb-4">
          <li className="flex items-center gap-2 text-sm text-[#a0a8b8]"><Zap className="h-3.5 w-3.5 text-[#f59e0b] shrink-0" /> Crypto payouts in minutes</li>
          <li className="flex items-center gap-2 text-sm text-[#a0a8b8]"><Trophy className="h-3.5 w-3.5 text-[#f59e0b] shrink-0" /> 7,000+ premium games</li>
          <li className="flex items-center gap-2 text-sm text-[#a0a8b8]"><Shield className="h-3.5 w-3.5 text-[#10b981] shrink-0" /> Provably fair & licensed</li>
        </ul>
        <button
          onClick={handleClick}
          className="w-full h-11 rounded-xl bg-[#4d7cfe] text-white font-medium text-sm btn-lift flex items-center justify-center gap-2"
          data-testid="sidebar-claim-bonus-btn"
        >
          Claim Bonus <ExternalLink className="h-3.5 w-3.5" />
        </button>
        <p className="text-[#64748b] text-[10px] text-center mt-2">18+ | T&Cs Apply | Play Responsibly</p>
      </div>
    </div>
  );
}
